export default __webpack_public_path__ + "static/media/cafe_1.7698af15.jpg";